import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import withPagination, { PaginationProps } from "app/utils/withPagination";
import WalletUserColumns from "app/components/AppComponents/SnapScan/Wallet/walletUserColumns";
import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import ConfigurableTable, {
  pickConfigs
} from "app/components/AppComponents/ConfigurableTable";

type Props = {
  name: string;
  vouchering: boolean;
  search: string;
};

const query = gql`
  query Currentlist(
    $search: String
    $vouchering: Boolean
    $offset: Int
    $limit: Int
  ) {
    wallet(
      search: $search
      vouchering: $vouchering
      offset: $offset
      limit: $limit
    ) {
      wallet_wallets {
        name
        display_name
      }
    }
  }
`;

const withData = graphql<any, Props & PaginationProps>(query, {
  options: ({ search, vouchering, pagination: { offset, limit } }) => ({
    fetchPolicy: "network-only",
    variables: {
      search: search,
      vouchering: vouchering,
      offset,
      limit
    }
  })
});

export default withPagination(
  withData(props => {
    const items = props.data?.wallet
      ? props.data.wallet?.map(value => {
          return value.wallet_wallets;
        })
      : [];

    return (
      <BOGraphQLLoader data={props.data}>
        <ConfigurableTable
          columnConfigs={pickConfigs(
            WalletUserColumns,
            props.vouchering
              ? ["Voucher Name", "Edit"]
              : ["Wallet Name", "Edit"]
          )}
          defaultColumns={
            props.vouchering
              ? ["Voucher Name", "Edit"]
              : ["Wallet Name", "Edit"]
          }
          rows={items}
          pagination={props.pagination}
          name={props.name}
        />
      </BOGraphQLLoader>
    );
  })
);
